module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('backTitleBar', {
    attrs: {
      "isBackHome": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-flex",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "page-data"
  }, [_c('div', {
    staticClass: "page-data-top"
  }, _vm._l((_vm.tabTimeList), function(item) {
    return _c('div', {
      key: item.value,
      staticClass: "page-data-div",
      class: _vm.tabTimeActive == item.value ? 'active' : '',
      on: {
        "click": function($event) {
          _vm.tabTimeActive = item.value
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0), _vm._v(" "), _c('DatePicker', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabTimeActive == 3),
      expression: "tabTimeActive == 3"
    }],
    staticClass: "page-data-time",
    staticStyle: {
      "width": "3.47rem"
    },
    attrs: {
      "editable": false,
      "value": _vm.time,
      "type": "date",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.timeChange2
    }
  }), _vm._v(" "), _c('DatePicker', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabTimeActive == 2),
      expression: "tabTimeActive == 2"
    }],
    staticClass: "page-data-time",
    staticStyle: {
      "width": "3.47rem"
    },
    attrs: {
      "editable": false,
      "value": _vm.time,
      "type": "month",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.timeChange2
    }
  }), _vm._v(" "), _c('DatePicker', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabTimeActive == 1),
      expression: "tabTimeActive == 1"
    }],
    staticClass: "page-data-time",
    staticStyle: {
      "width": "3.47rem"
    },
    attrs: {
      "editable": false,
      "value": _vm.time,
      "type": "year",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.timeChange2
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "page-user"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', [_vm._m(0), _vm._v(" "), _c('ul', _vm._l((_vm.saleList), function(item, $index) {
    return _c('li', {
      key: $index,
      staticClass: "li-item"
    }, [_c('div', {
      staticClass: "table-index"
    }, [_vm._v(_vm._s(item.productName))]), _vm._v(" "), _c('div', {
      staticClass: "table-main"
    }, [_vm._v(_vm._s(item.orderNum))]), _vm._v(" "), _c('div', {
      staticClass: "table-number"
    }, [_vm._v(_vm._s(item.totalSaleMoney))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "0.95rem"
    }
  })])])]), _vm._v(" "), _c('tabber', {
    attrs: {
      "tabActive": 1
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-table-header"
  }, [_c('div', {
    staticClass: "table-index"
  }, [_vm._v("商品名称")]), _vm._v(" "), _c('div', {
    staticClass: "table-main"
  }, [_vm._v("订单量")]), _vm._v(" "), _c('div', {
    staticClass: "table-number"
  }, [_vm._v("销售额")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27581774","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/data/product/rankList.vue
// module id = PAoT
// module chunks = 51